import React from "react"
import { useTranslation } from "react-i18next"
import { Grid } from "@material-ui/core"
import { HeaderHLPure, InputHLPure, DataPickerHLPure, TextAreaHLPure, CheckBoxHLPure } from "../../pures"
import "./add-survey.css"

const AddSurveyDataView = (props) => {
  const { t } = useTranslation()
  const { name, setName, startDate, setStartDate, endDate, setEndDate, description, setDescription, perVisit, setPerVisit, perBranch, setPerBranch, transl } = props

  const onInputChange = ({ target }, setValue) => {
    setValue(target.value)
  }

  const onCheckboxChange = ({ target }, fieldName) => {
    if (fieldName === 'perVisit') {
      setPerVisit(target.checked)
      setPerBranch(target.checked)
    } else if (fieldName === 'perBranch') {
      setPerBranch(target.checked)
    }
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <HeaderHLPure headingNumber={2} style={{ fontSize: '20px' }} title={transl('titleAddMainData')} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid container spacing={2}>
          <InputHLPure
            typeInput={"text"}
            labelInput={transl('name')}
            valueInput={name}
            handleChangeInput={(event) => onInputChange(event, setName)}
            inputActive
          />
          <Grid item xs={12}>
            <TextAreaHLPure
              labelTextArea={transl('description')}
              valueTextData={description}
              handleChangeTextArea={(event) => onInputChange(event, setDescription)}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <DataPickerHLPure className="element"
              labelDataPicker={t("publicityView.addPublicityStartDate")}
              valueDate={startDate}
              handleChangeDate={(event) => onInputChange(event, setStartDate)}
            />
          </Grid>
          <Grid item xs={12}>
            <DataPickerHLPure className="element"
              labelDataPicker={t("publicityView.addPublicityEndDate")}
              valueDate={endDate}
              handleChangeDate={(event) => onInputChange(event, setEndDate)}
            />
          </Grid>
          <Grid item xs={12}>
            <CheckBoxHLPure
              labelCheckBox={t("publicityView.perVisit")}
              valueCheckBox={perVisit}
              checkedState={perVisit}
              onChangeHandler={(e) => onCheckboxChange(e, "perVisit")}
              tooltipShow={true}
              positionTooltip={'top'}
              descriptionTooltip={transl('requestVisitTooltip')}
              informationIcon={true}
            />
          </Grid>
          <Grid item xs={12}>
            <CheckBoxHLPure
              labelCheckBox={t("publicityView.perBranch")}
              valueCheckBox={perBranch}
              checkedState={perBranch}
              onChangeHandler={(e) => onCheckboxChange(e, "perBranch")}
              disabled={perVisit}
              tooltipShow={true}
              positionTooltip={'top'}
              descriptionTooltip={transl('requestBranchTooltip')}
              informationIcon={true}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export { AddSurveyDataView as default }